export default __webpack_public_path__ + "static/media/complementary--when-rainy--g1.3e9a4e29.png";